import { Observable } from 'rxjs';

/** Reads a File as base64 string via FileReader. Emits the base64 payload (without data URL prefix) or errors. */
export function fileToBase64(file: File): Observable<string> {
  return new Observable<string>((subscriber) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.indexOf(',') >= 0 ? dataUrl.split(',')[1] : dataUrl;
      subscriber.next(base64 ?? '');
      subscriber.complete();
    };
    reader.onerror = () => {
      subscriber.error(reader.error);
    };
    reader.readAsDataURL(file);
  });
}
